import React, { useState, useEffect } from "react";
import "./basketballprograms.css";
import home_background1 from "../../Assets/Images/home/banner.png";

import StaticPageHeaders from "../../Components/StaticPageHeaders";
import VideoBanner from "../../Components/BasketballClinic/VideoBanner/VideoBanner";
import Team from "../../Components/Team/Team";
import UnlimitedBannerCom from "../../Components/InstructionsCom/UnlimitedBannerCom";
import Gallery from "../../Components/Home/Gallery/Gallery";
import Sponsors from "../../Components/Home/Sponsers/Sponsers";

import BasketBallClicnicBlock from "../../Components/BasketballClinic/BasketBallClicnicBlock/BasketBallClicnicBlock";

import img1 from "../../Assets/Images/BasketballPrograms/bbp1.png";
import img2 from "../../Assets/Images/BasketballPrograms/bbp2.png";
import img3 from "../../Assets/Images/BasketballPrograms/bbp3.png";
import img4 from "../../Assets/Images/BasketballPrograms/bbp4.png";

import { InstructionsContextProvider } from "../../APIContext/InstructionsContext";
import { useNavigate } from "react-router-dom";
import Packages from "../../Components/BasketballProgram/Packages/Packages";

import bg_un from "../../Assets/Images/TeamWorkout/team_work_unlim.png";
import SEO from "../../Components/SEO";
import EnquiryModal from "../../Components/EnquiryModal/EnquiryModal";

const SuccessStoriesBlocktwo = [
  {
    image: img1,
    name: "Saturday Night Lights",
    description:
      "Looking for skill development and games all wrapped into one awesome program? This is the program for you. Our staff puts players that join Saturday Night Lights through a 2 hour intense skill development workout. After the skill work, players get the opportunity to use their new skill in game action! Our coaches are there directing players through the games the entire time to help them understand the decision making process on the court. This is one of the first programs we ever put together and it is still a hit to this day! This program is broken up into two different groups based on the age of the players.",
    benifitsText: "Benefits of Sunday Sessions",
    benifits: [
      "Players work with players that are on their skill level or in their age group.",
      "Players can gauge their skill set based on other players in their group.",
      "Players work on communicating and learn to lead by example.",
      "Working in a small group lends itself to different styles of drills that include working with partners or multiple players.",
    ],
    orders: "left",
    buttonText: "Inquiry now",
    buttonLink: "",
  },
  {
    image: img2,
    name: "WEEKDAY Workouts",
    description:
      "Weekday Workouts is the equivalent to a Basketball Boot Camp… The program consists of a Hour and a half of intense basketball skill development. Players will work on attacking the basket, ball handling, shooting and more. In some cases, the players are broken up into teams where they can complete for the final 15 minutes of the program. This program is broken up into two different groups based on the age of the players.",
    benifitsText: "Weekday Workout Sessions",
    benifits: [
      "Perfect for Beginners - Allows trainers to focus in on teaching Shootin' School Basics.",
      "Specific needs of the individual player.",
      "Players work at their desired pace. If a player needs extra time or reps on a specific skill, they can take it. If players want to push the tempo they can go as quickly as they want.",
      "With Individual Instruction, players are able to get the maximum amount of reps in the hour.",
      "Perfect for Advanced Players - Allows trainers to focus in on",
    ],
    orders: "right",
    buttonText: "Inquiry now",
    buttonLink: "",
  },
  {
    image: img3,
    name: "MINI Ballers",
    description:
      "Teaching basic techniques to Mini-Ballers is one of our favorite things to do! For these beginners, our Mini-Ballers program is the best way to start their basketball career. Getting these youngster to do things properly at a young age prevents bad habits and builds a strong basketball foundation. The program focuses on teaching players to dribble with both hands, the proper way to take a layup, hand-eye coordination, basic strength and conditioning and basic stretching. While all of these concepts seem basic, they are crucial to the development of these young ballers!",
    benifitsText: "",
    benifits: [],
    orders: "left",
    buttonText: "Inquiry now",
    buttonLink: "",
  },
  {
    image: img4,
    name: "SATURDAY Morning Sessions",
    description:
      "Want to drastically improve your Basketball skills in only 10 weeks? Join our 10-week Saturday Morning Sessions. In this program, we work on all of the important basketball fundamentals to improve fast. Each week we focus on a new core skill for an hour on Saturday morning. We then compete and play at the end of our hour-long session to work on the skills we've learned in a game setting. At the end of this program, you will see a huge improvement in your skills and basketball confidence..",
    benifitsText: "Shooting The Lights Out Sessions",
    benifits: [
      "Perfect for Beginners - Allows trainers to focus in on teaching Shootin' School Basics.",
      "Specific needs of the individual player.",
      "Perfect for Advanced Players - Allows trainers to focus in on",
      "With Individual Instruction, players are able to get the maximum amount of reps in the hour.",
    ],
    orders: "right",
    buttonText: "Inquiry now",
    buttonLink: "",
  },
];

const BasketBallPrograms = () => {
  {
    /* <iframe width="560" height="315" src="https://www.youtube.com/embed/yZfBQ5jd5Z8?si=opBCwJvinzxsbMAV" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> */
  }
  const navigate = useNavigate();
  const images = [home_background1];
  const [showModal, setShowModal] = useState(false);

  const [index, setIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000); // Change image every 3 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, [images.length]);
  return (
    <>
      <SEO
        title="Programs - Shootin School Basketball"
        description=""
        url="https://shootinschool.com/programs/"
      />
      <div className="bp-page">
        <StaticPageHeaders title="BasketBall Programs" />
        <VideoBanner
          videoUrl="https://www.youtube.com/embed/yZfBQ5jd5Z8?si=opBCwJvinzxsbMAV"
          heading="Staten island’s Premier Basketball Instruction"
          buttonText="Inquiry now"
          buttonLink="#"
          setShowModal={setShowModal}
        />

        <InstructionsContextProvider>
          <Packages data={SuccessStoriesBlocktwo} setShowModal={setShowModal} />
        </InstructionsContextProvider>

        <div className="bp-container">
          <div className="bp-sss-layout">
            <div className="sss-grid" style={{ paddingTop: "30px" }}>
              {SuccessStoriesBlocktwo.map((successstory, i) => (
                <BasketBallClicnicBlock
                  key={i}
                  image={successstory.image}
                  name={successstory.name}
                  description={successstory.description}
                  benifitsText={successstory.benifitsText}
                  benifits={successstory.benifits}
                  order={successstory.orders}
                  buttonText={successstory.buttonText}
                  buttonLink={successstory.buttonLink}
                  setShowModal={setShowModal}
                />
              ))}
            </div>
          </div>
        </div>

        <UnlimitedBannerCom brValue={1.28} />
        <Gallery />
        <Sponsors />
      </div>
      {showModal && <EnquiryModal onClose={() => setShowModal(false)} />}
    </>
  );
};

export default BasketBallPrograms;
